import React, { useEffect } from "react";
import UseFormSwitch from "./UseFormSwitch";
import UseFormLabelInput from "./UseFormLabelInput";
import UseFormSelect from "./UseFormSelect";
import UseFormRadio from "./UseFormRadio";
import UseLenderSelect from "./UseLenderSelect";
import UseFormSwitchList from "./UseFormSwitchList";
import UseFormCheckbox from "./UseFormCheckbox";
import UseFormTextareaInput from "./UseFormTextareaInput";
import UseFormContent from "./UseFormContent";
import UseFormTable from "./UseFormTable";
import UseFormFileInput from "./UseFormFileInput";
import UseMultiSelect from "./UseMultiSelect";
import UseFormPhoneNumberInput from "./UseFormPhoneNumberInput";
import UseOtp from "./UseOtp";
import UseSignature from "./UseSignature";
import UseDate from "./UseDate";
import UsePattern from "./UsePattern";
import UsePencil from "./UsePencil";
import UseBadge from "./UseBadge";
import UseStarRating from "./UseStarRating";

// import UseFormMultiSelect from "./UseFormMultiSelect";

const InputBox = (inputDetails) => {
  const {
    type,
    watch,
    dependsOn,
    dependsType,
    field,
    defaultValue,
    setValue,
    errors,
    show = false,
  } = inputDetails;

  const allConditionsMet = (conditions) =>
    dependsType === "any"
      ? conditions.some((condition) =>
          condition?.depCondition === "notEqual"
            ? JSON.stringify(watch(condition.field)) !==
              JSON.stringify(condition.value)
            : JSON.stringify(watch(condition.field)) ===
              JSON.stringify(condition.value)
        )
      : conditions.every((condition) =>
          condition?.depCondition === "notEqual"
            ? JSON.stringify(watch(condition.field)) !==
              JSON.stringify(condition.value)
            : JSON.stringify(watch(condition.field)) ===
              JSON.stringify(condition.value)
        );

  const condition = !Array.isArray(dependsOn) || allConditionsMet(dependsOn);

  const componentMap = {
    switch: UseFormSwitch,
    text: UseFormLabelInput,
    amount: UseFormLabelInput,
    email: UseFormLabelInput,
    password: UseFormLabelInput,
    select: UseFormSelect,
    lenderSelect: UseLenderSelect,
    date: UseDate,
    time: UseFormLabelInput,
    radio: UseFormRadio,
    number: UseFormLabelInput,
    switchList: UseFormSwitchList,
    checkbox: UseFormCheckbox,
    textarea: UseFormTextareaInput,
    content: UseFormContent,
    table: UseFormTable,
    file: UseFormFileInput,
    multiSelect: UseMultiSelect,
    phoneNumber: UseFormPhoneNumberInput,
    otp: UseOtp,
    sign: UseSignature,
    pattern: UsePattern,
    pencil: UsePencil,
    star: UseStarRating,
    badge: UseBadge,
  };

  const Component = componentMap?.[type] || Other;
  useEffect(() => {
    if (defaultValue && condition) {
      setValue(field, defaultValue);
    }
  }, [defaultValue, field, setValue, condition]);

  return condition ? (
    <div className={`m-3`}>
      <Component {...inputDetails} error={errors?.[field]?.message} />
    </div>
  ) : (
    !condition && show && (
      <Component
        {...inputDetails}
        disable={true}
        error={errors?.[field]?.message}
      />
    )
  );
};

export default InputBox;
const Other = () => {
  return <p>Not Available</p>;
};
